import Error from './Error'
import localize from '../../higherOrderComponents/localize'
export default localize(Error)



// WEBPACK FOOTER //
// ./src/routes/Error/index.js